import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

const DialogWrapper = styled.div`
  ${flexCenter};
`;

export default DialogWrapper;
